import PropTypes from 'prop-types'
import AddressSelectorFieldContent from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/AddressSelectorFieldContent'

const AddressSelectorField = ({ module, validations, saleName, hidden }) => {
  if (hidden) return null

  return <AddressSelectorFieldContent module={module} validations={validations} saleName={saleName} />
}

AddressSelectorField.propTypes = {
  module: PropTypes.string,
  validations: PropTypes.object,
  saleName: PropTypes.string,
  hidden: PropTypes.bool,
}

export default AddressSelectorField
